var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconMarkedAsComplete(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#18a1db",
    d: "M2.604 16.392V2.186h11.473v11.93l2.186-1.805V1.093C16.263.489 15.774 0 15.171 0H1.51C.908 0 .42.49.42 1.093v16.391c0 .604.489 1.093 1.092 1.093h9.536l-1.545-2.185z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#18a1db",
    d: "M19.41 11.749a.546.546 0 0 0-.723-.025l-5.012 4.143-3.34-2.004a.546.546 0 0 0-.727.784l3.62 5.122c.1.143.265.23.44.23h.006a.544.544 0 0 0 .44-.222l5.362-7.308a.547.547 0 0 0-.066-.72z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#18a1db",
    d: "M11.62 3.825H5.061a1.093 1.093 0 0 0 0 2.185h6.557a1.092 1.092 0 0 0 0-2.185z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#18a1db",
    d: "M11.62 7.103H5.061a1.093 1.093 0 0 0 0 2.185h6.557a1.092 1.092 0 0 0 0-2.185z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#18a1db",
    d: "M11.62 10.381H5.061a1.093 1.093 0 0 0 0 2.186h6.557a1.092 1.092 0 0 0 0-2.186z"
  })))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMarkedAsComplete);
export default __webpack_public_path__ + "static/media/icon-marked-as-complete.d1cb7433.svg";
export { ForwardRef as ReactComponent };